import AdministrationListItemCount, {
  AdministrationListItemName,
} from './AdministrationListComponents';
import React, { useMemo } from 'react';
import CountableText from '../../../components/global/CountableText/CountableText';
import { styled } from 'styled-components';
import { Row, Text } from '@ydistri/ds';
import { CountableDetail } from './administrationItemsTypes';
import { formatDate } from '@ydistri/generic-utils';
import { Popover } from 'antd';
import { EntityListDescriptionInfoIconTooltip } from './EntityListDescription';

const CardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const IconWrapper = styled.div`
  margin-left: auto;
`;

const descriptionInfoIconStyle: React.CSSProperties = {
  marginLeft: 'auto',
};

export interface AdministrationItemCardProps {
  name?: string | null;
  description?: string | null;
  updatedAt: string;
  updatedAtPopoverContent?: React.ReactNode;
  countable?: CountableDetail[];
  summary?: React.ReactNode;
  archiveIndicator?: React.ReactNode;
  icon?: React.ReactNode;
  avatar?: React.ReactNode;
  $minNameWidth?: string;
}

const AdministrationItemCard: React.FC<AdministrationItemCardProps> = ({
  name,
  description,
  updatedAt,
  updatedAtPopoverContent,
  countable,
  summary,
  archiveIndicator,
  icon,
  avatar,
  $minNameWidth,
}) => {
  const countableText = useMemo(() => {
    if (summary !== undefined) return summary;

    if (countable && countable.length > 0 && countable.every(item => item.count === 0)) {
      return <Text>empty</Text>;
    }

    return countable
      ?.filter(countable => countable.count > 0)
      .map(countable => (
        <CountableText
          key={countable.description}
          value={countable.count}
          word={countable.description}
          highlighting="none"
        />
      ));
  }, [countable, summary]);

  return (
    <Row $flexGrow={1} $alignItems="center" $gap="1rem" $flexWrap="nowrap">
      {avatar && <IconWrapper>{avatar}</IconWrapper>}
      <CardWrapper data-type="AdministrationItemCard">
        <AdministrationListItemName data-type="AdministrationItem-Name" $minWidth={$minNameWidth}>
          <Row $flexGrow={1} $gap="0.5rem">
            <Text $size="large" $semiBold>
              {name}
            </Text>
            {archiveIndicator}
            {description && (
              <EntityListDescriptionInfoIconTooltip
                description={description}
                style={descriptionInfoIconStyle}
              />
            )}
          </Row>
        </AdministrationListItemName>
        <Row $justifyContent="space-between" $alignItems="center" $width="100%">
          {countableText && (
            <AdministrationListItemCount>{countableText}</AdministrationListItemCount>
          )}
          {updatedAtPopoverContent ? (
            <Popover content={updatedAtPopoverContent}>
              <Text>{formatDate(updatedAt)}</Text>
            </Popover>
          ) : (
            <Text>{formatDate(updatedAt)}</Text>
          )}
        </Row>
      </CardWrapper>
      {icon && <IconWrapper>{icon}</IconWrapper>}
    </Row>
  );
};

export default AdministrationItemCard;
